import React, { useState } from "react";
import ProtocolSection from "./ProtocolSection";
import QuestionnaireSection from "./QuestionnaireSection";

const purple = "#2E2868";


const TabSection = ({ subject, subjectId }) => {
  const [activeTab, setActiveTab] = useState("questionnaires");

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div style={{ width: "100%", margin: "0 auto", padding: "20px" }}>
      {/* Tab Navigation */}
      <div className="d-flex justify-content-between mb-3 ">
        <span
          style={{
            borderBottom:
              activeTab === "questionnaires" ? `3px solid ${purple}` : "none",
            color: "#2E2868",
            fontSize: "18px",
            fontWeight: "bold",
            cursor: "pointer"
          }}
          onClick={() => handleTabChange("questionnaires")}
        >
          Questionnaires
        </span>

        <span
          style={{
            color: "#2E2868",
            fontSize: "18px",
            fontWeight: "bold",
            borderBottom:
              activeTab === "protocols" ? `3px solid ${purple}` : "none",
            cursor: "pointer"
          }}
          onClick={() => handleTabChange("protocols")}
        >
          Protocols
        </span>
      </div>

      {/* Display the active tab content */}
      {activeTab === "questionnaires" && <QuestionnaireSection subjectId={subjectId} />}
      {activeTab === "protocols" && <ProtocolSection subject={subject} />}
    </div>
  );
};

export default TabSection;